import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const menuItems = [
  { path: "/admin/dashboard", icon: "bi-speedometer2", label: "Dashboard" },
  { path: "/admin/tours", icon: "bi-map", label: "Tour Programs" },
  { path: "/admin/voters", icon: "bi-people", label: "Voters" },
  { path: "/admin/grievances", icon: "bi-chat-left-text", label: "Grievances" },
  { path: "/admin/projects", icon: "bi-building", label: "Dev Projects" },
  { path: "/admin/beneficiary", icon: "bi-heart", label: "Beneficiary" },
  { path: "/admin/contacts", icon: "bi-person-lines-fill", label: "Contacts" },
  { path: "/admin/messages", icon: "bi-chat-dots", label: "Messages" },
  { path: "/admin/reports", icon: "bi-bar-chart", label: "Reports" },
  { path: "/admin/users", icon: "bi-person-gear", label: "Users" },
  { path: "/admin/masters", icon: "bi-gear", label: "Masters" },
];

const Sidebar = ({ isOpen }) => {
  const { logout } = useAuth();

  return (
    <div
      className="d-flex flex-column"
      style={{
        width: isOpen ? "250px" : "70px",
        minHeight: "100vh",
        background: "linear-gradient(180deg, #1a3c5e 0%, #2d6a4f 100%)",
        transition: "width 0.3s ease",
        overflow: "hidden",
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 1000,
      }}
    >
      {/* Logo */}
      <div
        className="d-flex align-items-center p-3 border-bottom border-white border-opacity-25"
        style={{ minHeight: "64px" }}
      >
        <i className="bi bi-building text-white fs-4 flex-shrink-0"></i>
        {isOpen && (
          <span
            className="text-white fw-bold ms-2 text-nowrap"
            style={{ fontSize: "15px" }}
          >
            Nammakshetra
          </span>
        )}
      </div>

      {/* Menu */}
      <nav className="flex-grow-1 py-2">
        {menuItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `d-flex align-items-center px-3 py-2 text-decoration-none mx-2 my-1 rounded-3 ${
                isActive
                  ? "bg-white bg-opacity-25 text-white"
                  : "text-white text-opacity-75"
              }`
            }
            style={{ minHeight: "42px", transition: "all 0.2s" }}
          >
            <i className={`bi ${item.icon} fs-5 flex-shrink-0`}></i>
            {isOpen && (
              <span className="ms-3 text-nowrap small fw-medium">
                {item.label}
              </span>
            )}
          </NavLink>
        ))}
      </nav>

      {/* Logout */}
      <div className="p-2 border-top border-white border-opacity-25">
        <button
          onClick={logout}
          className="btn d-flex align-items-center w-100 text-white text-opacity-75 px-3 py-2 rounded-3"
          style={{ background: "transparent", minHeight: "42px" }}
        >
          <i className="bi bi-box-arrow-left fs-5 flex-shrink-0"></i>
          {isOpen && (
            <span className="ms-3 small fw-medium text-nowrap">Logout</span>
          )}
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
